import React from "react"
import PropTypes from "prop-types"
import { Tooltip } from "antd"
import { useTranslation } from "react-i18next"
import { Icon } from "ui/Icon"
import styles from "./index.module.css"

/**
 * "Leslie Alexander (Capitan) · Unavailable ⓘ" — an assigned resource a blackout has taken out
 * from under the booking it is still attached to.
 *
 * The chip stays removable rather than disappearing: the assignment is real until a guide
 * replaces or drops it, and a chip that vanished would leave the booking looking staffed. The
 * info icon carries the reason, which is the only place the guide can read *why* without leaving
 * the page.
 */
const UnavailableChipLabel = ({ label, reason }) => {
  const { t } = useTranslation()
  const unavailableText = t("booking.reservation_detail.unavailable", { defaultValue: "Unavailable" })

  return (
    <span className={styles.wrapper}>
      <span className={styles.label}>{label}</span>
      <span className={styles.state}>{`· ${unavailableText}`}</span>
      {/* antd renders no tooltip for an empty title, so a reasonless conflict simply has none. */}
      <Tooltip title={reason || ""}>
        <span className={styles.info}>
          <Icon name="Info" width={16} height={16} color="var(--color-primary)" />
        </span>
      </Tooltip>
    </span>
  )
}

UnavailableChipLabel.propTypes = {
  label: PropTypes.string.isRequired,
  /** The blackout's reason, when it gave one. */
  reason: PropTypes.string
}

export default UnavailableChipLabel
